export class AlphabetGenerator {
  private _alphabet: string[]
  private _index: number

  public constructor() {
    this._alphabet = this._generateAlphabet('A', 'Z')
    this._index = 0
  }

  public next(): string {
    const letter = this._alphabet[this._index % this._alphabet.length]
    this._index++
    return letter
  }

  public nextAfter(letter: string): string {
    const letterIndex = this._alphabet.indexOf(letter)
    return this._alphabet[(letterIndex + 1) % this._alphabet.length]
  }

  public reset() {
    this._index = 0
  }

  private _generateAlphabet(firstCharacter, lastCharacter) {
    const alphabet = []
    const j = lastCharacter.charCodeAt(0)

    for (let i = firstCharacter.charCodeAt(0); i <= j; ++i) {
        alphabet.push(String.fromCharCode(i))
    }
    return alphabet
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/helpers/alphabet-generator/alphabet-generator.ts